import { Theme, useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';

import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import Popper from '@mui/material/Popper';
import TextField from '@mui/material/TextField';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { IItemWithString } from 'lib/type/common';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { StFormLabel } from './ConnectUsForm.styles';
import ErrorIcon from './error_icon.svg';

interface IEmailAutocompleteProps {
  emailTitle: Field<string>;
  emailDomains: IItemWithString[];
  fieldProps: ControllerRenderProps<FieldValues, 'emailAddress'>;
  name: string;
  errors: any;
  isMobile: boolean;
  formElements: any;
}

const ConnectUsemail: React.FC<IEmailAutocompleteProps> = (props) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const [domainList, setDomainList] = useState<string[]>([]);

  useEffect(() => {
    const doamins: string[] = props?.emailDomains?.map((item) => item?.fields?.name?.value);
    const newValue = props?.fieldProps?.value ? props?.fieldProps?.value : '';
    if (props?.fieldProps?.value !== undefined) {
      const atIndex: number | string = newValue.indexOf('@');
      if (atIndex !== -1) {
        const prefix = props?.fieldProps?.value?.slice(0, (atIndex as number) + 1);
        setDomainList(doamins.map((item: any) => `${prefix}${item}`));
      }
    } else {
      setDomainList([]);
    }
  }, [props, props?.emailDomains, props?.fieldProps?.value]);

  const handleInputChange = (_event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    props?.fieldProps?.onChange(value);
  };

  const handleOnChange = (_event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    props?.fieldProps.onChange(value);
  };

  const filterOptions = (options: string[], { inputValue }: { inputValue: string }) => {
    const input = inputValue.trim().toLowerCase();
    return options?.filter((option: string) => option?.toLowerCase().startsWith(input));
  };

  return (
    <FormControl sx={{ width: props?.isMobile ? '300px' : '450px', gap: '0.25rem' }}>
      <StFormLabel htmlFor={props?.name}>
        <Text field={props?.emailTitle} />
      </StFormLabel>
      <Autocomplete
        freeSolo
        {...props.fieldProps}
        sx={{
          background: theme.palette.white.main,
          borderRadius: '0.5rem',
          '.MuiOutlinedInput-root .MuiAutocomplete-input': {
            color: theme.palette.black.main,
            padding: '0',
          },
          '.MuiAutocomplete-popper': { background: 'red' },
          '.MuiInputBase-root': {
            padding: '10px 15px',
          },
          '.MuiInputBase-input': {
            padding: '4px 0',
            fontFamily: 'Proxima Nova',
            fontSize: '16px',
            lineHeight: '16px',
          },
        }}
        disableClearable
        options={domainList}
        filterOptions={filterOptions}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onOpen={() => {
          setOpen(true);
        }}
        onInputChange={handleInputChange}
        onChange={handleOnChange}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={props?.formElements?.fields?.placeholder?.value || ''}
            sx={{
              '& fieldset': { border: 'none' },
              border: (theme: Theme) =>
                props?.errors['emailAddress'] !== undefined
                  ? `1px solid ${theme.palette.error.main} !important`
                  : `1px solid ${theme.palette.neutral3.main}`,
              borderRadius: '0.5rem',
            }}
            inputProps={{
              ...params.inputProps,
              maxLength: props?.formElements?.fields?.maxLength?.value,
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  {props?.errors['emailAddress'] !== undefined ? (
                    <InputAdornment
                      position="start"
                      sx={{
                        minHeight: '15px',
                        minWidth: '15px',
                      }}
                    >
                      <Image src={ErrorIcon} width={15} height={15} />
                    </InputAdornment>
                  ) : (
                    <></>
                  )}
                </>
              ),
            }}
          />
        )}
        renderOption={(params, option) => (
          <span {...params} style={{ color: theme.palette.black.main }}>
            {option}
          </span>
        )}
        PopperComponent={({ ...props }) => (
          <Popper
            {...props}
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [0, 10],
                },
              },
            ]}
          />
        )}
        noOptionsText=""
      />
      <>
        {props?.errors['emailAddress'] !== undefined && (
          <Box
            sx={{
              fontSize: '12px',
              fontFamily: 'Proxima Nova SemiBold',
            }}
          >
            {props?.errors['emailAddress'].message ||
              props?.formElements?.fields?.regexErrorMessage?.value}
          </Box>
        )}
      </>
    </FormControl>
  );
};

export default ConnectUsemail;
